import { IView } from "../Core/View";
import { ViewFactory } from "../Core/Factories/ViewFactory";

import { GroupTypeView } from "./Club/GroupTypeView";
import { PersonalTrainingView } from "./Club/PersonalTrainingView";

ViewFactory.setRegistry({
    'GroupTypeView': GroupTypeView,
    'PersonalTrainingView': PersonalTrainingView
});


// WEBPACK FOOTER //
// ./www/js/Pages/Club.ts